module.exports = __webpack_public_path__ + "static/media/crest-1.ec8e1b3c.png";